import images from "../constant/images";

export const partenaireData = [
  { id: 1, image: images.avene },
  { id: 2, image: images.foodsgoods },
  { id: 3, image: images.hitradio },
  { id: 4, image: images.sport },
  { id: 5, image: images.mediaglobal },
  { id: 6, image: images.women },
  { id: 7, image: images.korean },
  { id: 8, image: images.magazine },
];
